const addToCartBottom = $('#add-to-cart-bottom');

if (addToCartBottom.length) {
  addToCartBottom.on('click', function () {
    let button = $(this);
    button.prop('disabled', true);
    setTimeout(function () {
      button.prop('disabled', false);
    }, 1000);

    $('.product-actions .product-add-to-cart button[data-button-action="add-to-cart"]').trigger('click');
  });
}

const pricesBottom = document.querySelector('.product-actions-bottom');

if (pricesBottom) {
  pricesBottom.addEventListener('click', function (e) {
    if (e.target.classList.contains('add-to-cart')) {
      const productAddToCartButton = document.querySelector(
        '.product-actions .product-add-to-cart button[data-button-action="add-to-cart"]',
      );
      if (productAddToCartButton) {
        productAddToCartButton.click();
      }
    }
  });
}
